import type { FC } from 'react';
import styles from './DataDivider.module.css';

type TDataDividerProps = {
    date: string;
};

const DataDivider: FC<TDataDividerProps> = ({ date }) => {
    return (
        <div className={styles.stickyWrapper}>
            <div className={styles.wrapper}>
                <hr />
                <span className={styles.dataWrapper}>{date}</span>
                <hr />
            </div>
        </div>
    );
};

export default DataDivider;
